<cx-carousel [items]="items$ | async" [title]="title$ | async" [template]="carouselItem" itemWidth="285px">
</cx-carousel>

<ng-template #carouselItem let-item="item">
  <span tabindex="0">
    <cx-media
      alt="{{ item.name }}"
      [container]="item.images?.PRIMARY"
      [routerLink]="{ cxRoute: 'product', params: item } | cxUrl"
      format="product"
    ></cx-media>
    <h4>
      {{ item.name }}
    </h4>
    @if (isLoggedIn$ | async) {
      <ng-container class="price">
        @if (userPermissionService.showPrice) {
          <div class="price">
            {{ item.price?.formattedValue }}
          </div>
        }
      </ng-container>
    }
    <div>
      <button class="btn btn-primary btn-block btn-small" [routerLink]="{ cxRoute: 'product', params: item } | cxUrl">
        View product
      </button>
    </div>
  </span>
</ng-template>
